import * as ActionTypes from '../ActionTypes';

// Module
export const GetModule = () => {
    return {
        type: ActionTypes.MODULE_GET_REQUEST,
    }
}